import script from "./PlanResources.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanResources.vue?vue&type=script&setup=true&lang=js"

import "./PlanResources.vue?vue&type=style&index=0&id=95cc6278&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95cc6278"]])

export default __exports__